module.exports = __webpack_public_path__ + "static/media/new-york-3.bc68d88d.svg";